import styled from "styled-components";
import { textTheme, colorTheme } from "../../theme";

type DetailScheduleType = {
  status: string;
};

type TextType = {
  green?: true;
};

export const Container = styled.div`
  width: 499px;
  height: 412px;
  padding: 31px 40px 38px 40px;
  border: 1px solid rgba(226, 229, 230, 0.35);
  box-sizing: border-box;
  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
`;

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: flex-end;
`;

export const Title = styled.span`
  ${textTheme.h4};
`;

export const YearContainer = styled.div`
  border: 1.5px solid #e2e5e6;
  background: rgba(9, 142, 223, 0.08);
  border-radius: 4px;
  height: 34px;
  width: 101px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Year = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: -0.015em;
  color: #737b7d;
  margin: 0px 15px;
`;

export const Icon = styled.img`
  &:hover {
    cursor: pointer;
  }
`;

export const ProgressBarContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 190px;
`;

export const DetailContainer = styled.div`
  position: absolute;
  top: 63%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DetailTitle = styled.span`
  ${textTheme.subtitle2};
  color: ${colorTheme.grayDark};
`;

export const DetailProgress = styled.span`
  ${textTheme.price};
`;

export const DetailSchedule = styled.div<DetailScheduleType>`
  background: ${props =>
    props.status === "red"
      ? `${colorTheme.red}`
      : props.status === "yellow"
      ? `${colorTheme.yellow}`
      : "#38D9A9"};
  padding: 5px 13px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${colorTheme.white};
  ${textTheme.subtitle2}
`;

export const History = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

export const Checkin = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CoffeeIcon = styled.img`
  margin-bottom: 10px;
`;

export const Text = styled.span<TextType>`
  color: ${props => (props.green ? "#38D9A9" : "#000000")};
  ${textTheme.subtitle1}
`;

export const Interval = styled.span`
  ${textTheme.subtitle1}
  font-weight: 400;
  color: ${colorTheme.grayDark};
`;
